<template>
  <h1 style="color: white; text-align:center;">
    How's The Weather There ? Know Here !!
  </h1>
  <input
    type="search"
    name="Search Here"
    placeholder="Search..."
    v-model="name"
    id="search_bar"
    
  />
  <input
    type="submit"
    name="Search Here"
    placeholder="Search..."
    id="sb"
    value="Search"
    @click="fetch_data"
  />

  <dataShow :weather="weather"></dataShow>
</template>

<script>
import axios from "axios";
import dataShow from "./dataShow";
export default {
  name: "search",
  components: {
    dataShow,
  },

  data() {
    return {
      name: "",
      api_key: "391ddda2c9f2df8352ea7482e747e0fe",
      weather: null,
    };
  },
  methods: {
    fetch_data: function () {
      if(this.name != ""){
      axios
        .get(
          `https://api.openweathermap.org/data/2.5/weather?q=${this.name}&appid=${this.api_key}&units=metric`
        )
        .then((res) => {
          this.weather = res.data;
       
        })
        .catch((err) => {console.log(err); alert("404 City Not Found Or Check Internet Connection");});
    }
    else{
      alert("Please Enter City Name");
    }
    },
  },
};
</script>

<style>
#search_bar,
#sb {
  
  color: white;
  margin: 30px 8px 30px 8px;
  display: block;
  overflow: hidden;
  width: 97%;
  /* margin-bottom: 30px; */
  display: block;
  padding: 5px;
  /* color: #313131; */
  font-size: 20px;
  border-radius: 20px;
  border: 2px solid;
  outline: none;
  background: none;
}
#sb:hover{
  color:violet;
  background: linear-gradient(to right, #c02425, #f0cb35);;
}
::placeholder{
  color: white;
}
</style>